import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetTemplateList extends Event {
    eventName = 'oms_getTemplateList';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get language
     * 
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let theme_id = data.theme_id;
        let product_id = data.product_id;
        let category_id = data.category_id;
        let location_id = data.location_id;
        let page_id = data.page_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';
        let templateList = new LocalStorage.TemplateList(clientId,  'flexy');
        let template = templateList.getData();
        if (template) {
            thisObj.onSuccessEvent(thisObj.formatResponseData(template), { 'action': action, 'request_id': requestId });
        }

        // request data
        data.endPoint = application_settings.endPoints.getTemplateList;
        data.data = {
            client_id: clientId,
            theme_id: theme_id,
            product_id: product_id,
            category_id: category_id,
            location_id: location_id,
            page_id: page_id
        };
        
        // send request
        this.sendRequest(data, function (response) {
            if (response) {
                let TemplateList = new LocalStorage.TemplateList(clientId,  'flexy');

                //add data to storage
                TemplateList.setData(response);

                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
        
    }
}

export default GetTemplateList;